import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Willkommen zurück!");
      navigate("/dashboard");
    } else {
      toast.error(res.error || "Anmeldung fehlgeschlagen");
    }
  };

  const onGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 grain">
      <div className="w-full max-w-md relative z-10">
        <Link to="/" className="flex items-center justify-center mb-10">
          <Logo size={72} withText />
        </Link>
        <div className="rounded-2xl border border-white/10 bg-zinc-950 p-8 shadow-2xl">
          <h1 className="font-heading text-3xl mb-2">Anmelden</h1>
          <p className="text-sm text-zinc-400 mb-8">Schön, dich wiederzusehen.</p>

          <Button
            data-testid="login-google-button"
            onClick={onGoogle}
            variant="outline"
            className="w-full rounded-full border-white/15 bg-transparent hover:bg-white/5 mb-6 h-11"
          >
            <GoogleIcon /> Mit Google fortfahren
          </Button>

          <div className="flex items-center gap-3 my-6">
            <div className="flex-1 h-px bg-white/10" />
            <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">oder</span>
            <div className="flex-1 h-px bg-white/10" />
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-[0.2em] text-zinc-500">E-Mail</Label>
              <Input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-zinc-900 border-zinc-800 h-11"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-[0.2em] text-zinc-500">Passwort</Label>
              <Input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-zinc-900 border-zinc-800 h-11"
              />
            </div>
            <Button
              data-testid="login-submit"
              type="submit"
              disabled={submitting}
              className="w-full rounded-full bg-primary text-primary-foreground hover:brightness-110 h-11"
            >
              {submitting ? "Anmelden…" : "Anmelden"}
            </Button>
          </form>

          <p className="text-center text-sm text-zinc-400 mt-6">
            Noch kein Konto?{" "}
            <Link to="/register" data-testid="login-go-register" className="text-primary hover:underline">
              Jetzt registrieren
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24">
      <path fill="#FFC107" d="M21.8 10.2H12v3.9h5.7c-.3 1.8-2 5-5.7 5-3.4 0-6.2-2.8-6.2-6.4 0-3.5 2.8-6.4 6.2-6.4 1.9 0 3.2.8 4 1.5l2.7-2.6C16.9 3.7 14.7 3 12 3 6.9 3 2.8 7 2.8 12.1S6.9 21.2 12 21.2c6.9 0 9.2-4.8 9.2-7.3 0-.5 0-1-.1-1.7z" />
    </svg>
  );
}
